<template>
    <div class="flipper">
        <div class="flipper__wrapper" v-bind:style="wrapperStyle">
            <div class="flipper__face flipper__face--front">
                <slot name="front"></slot>
            </div>
            <div class="flipper__face flipper__face--back">
                <slot name="back"></slot>
            </div>
        </div>
    </div>
</template>
<style lang="stylus">

    .flipper
        position relative
        z-index 1
        width 50px
        height 100px
        display inline-block

    .flipper__wrapper
        width 100%
        height 100%
        backface-visibility hidden
        -webkit-backface-visibility hidden
        transform-style preserve-3d
        -webkit-transform-style preserve-3d
        transition transform .7s
        .flipper--flipped &
            transform rotateY(180deg)


    .flipper__face
        position absolute
        width 100%
        height 100%
        &.flipper__face--back
            transform rotateY(180deg)

</style>
<script>
    export default{
        props: {
            transform: {
                type: String,
                default: ''
            }
        },
        computed: {
            wrapperStyle() {
                if (this.transform) {
                    return 'transform: rotateY(30deg)';
                } else {
                    return ''
                }
            }
        }
    }

</script>



// WEBPACK FOOTER //
// flipper.vue?48072718